import * as pluralize from 'pluralize'
import moment from 'moment'

export default {
  subscriptionToEdit: (state, getters) => {
    return state.subscriptionToEdit
  },
  getPlans: (state, getters) => {
    if (state.plans) {
      return state.plans
    }
  },
  paymentRequestSchema: (state, getters) => {
    if (state.paymentRequestSchema) {
      return state.paymentRequestSchema
    }
  },
  getMySubscriptions: (state) => {
    return state.mySubscriptions
  },
  getActiveSubscription: (state, getters) => {
    return (getters.getMyInfo && state.activeSubscriptions.length) ? state.activeSubscriptions[0] : null
  },
  getActiveUserSubscription: (state) => {
    return state.activeUserSubscriptions.length ? state.activeUserSubscriptions[0] : null
  },
  planName (state, getters) {
    if (getters.getActiveSubscription) {
      let plan = getters.getActiveSubscription.plan
      let range = 'monthly'
      if (plan && plan.transform_usage) {
        const transform = plan.transform_usage
        if (transform) {
          range = `every ${transform.divide_by} months`
        }
      }
      if (plan && !plan.nickname) plan.nickname = 'Group Plan'
      return `${plan.nickname} (${range})`
    }
  },
  planPrice (state, getters) {
    let price = 0
    if (getters.getActiveSubscription) {
      const plan = getters.getActiveSubscription.plan
      price = plan.amount / 100
    }
    return price
  },
  planRange (state, getters) {
    let range = 'monthly'
    if (getters.getActiveSubscription) {
      const { interval, interval_count } = getters.getActiveSubscription.plan
      range = `per ${interval}`
      if (interval_count > 1) {
        range = `every ${interval_count} ${pluralize(interval)}`
      }
    }
    return range
  },
  autoRenewLabel (state, getters) {
    let label = 'Auto renews'
    if (getters.getActiveSubscription) {
      const subscription = getters.getActiveSubscription
      if (subscription.cancel_at_period_end) label = 'Cancels'
    }
    return label
  },
  autoRenewDate (state, getters) {
    if (getters.getActiveSubscription) {
      const { plan, billing_cycle_anchor } = getters.getActiveSubscription
      const baseDate = moment.unix(billing_cycle_anchor)
      if (plan && plan.interval) {
        let nextDate = baseDate.add(plan.interval_count, pluralize(plan.interval))
        return nextDate.format('MMMM Do YYYY')
      }
    }
    return null
  },
  getActivePlan: (state, getters) => {
    if (getters.getActiveSubscription) {
      return getters.getActiveSubscription.plan
    }
  },
  getActiveUserPlan: (state, getters) => {
    if (getters.getActiveUserSubscription) {
      return getters.getActiveUserSubscription.plan
    }
  },
  getMyPayments: state => state.myPayments,
  getStripeKey: state => state.stripeKey
}



// WEBPACK FOOTER //
// ./src/app/store/subscriptions/getters.js